import React from "react";
import CommunicationExamples from "./CommunicationExamples";

export default function WhatHappensNext() {
  return (
    <>
      <h2 className="h2">What happens next?</h2>
      <p>
        You'll receive a welcome message shortly, confirming your enrollment.
      </p>
      <p>
        Then once you have made your appointment, and seen an optometrist, when
        it's time for your next eye check, we'll send you a friendly reminder to
        keep you on track.
      </p>
      <p>
        With KeepSight, you'll never miss an important appointment and can rest
        easy knowing your eyes are in good hands.
      </p>
      <p>
        To give you an idea of how we'll help you stay on top of your eye
        health, here are a couple of examples of the messages you'll receive:
      </p>
      <p className="mb-0">
        These messages will be sent to you via SMS or email, making it easy for
        you to stay informed and never miss an appointment.
      </p>
      <CommunicationExamples />
    </>
  );
}
